var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 26,
    viewBox: "0 0 82 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6664 11.9155H51.8331C51.8331 6.35804 47.6373 2.16663 42.0723 2.16663V4.33329C46.4728 4.33329 49.6664 7.52154 49.6664 11.9155Z",
    fill: "#4C7EBD",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0832 8.66672C44.3614 8.66672 45.3332 9.63847 45.3332 11.9167H47.4998C47.4998 8.42297 45.5769 6.50006 42.0832 6.50006V8.66672ZM45.7903 14.5633C45.5822 14.3741 45.3086 14.2732 45.0274 14.2819C44.7463 14.2906 44.4795 14.4082 44.2834 14.6099L41.691 17.276C41.067 17.1568 39.8125 16.7657 38.5212 15.4776C37.2298 14.1852 36.8387 12.9275 36.7228 12.3078L39.3867 9.71431C39.5887 9.51836 39.7065 9.25153 39.7152 8.97028C39.7239 8.68903 39.6228 8.41543 39.4333 8.20739L35.4304 3.80581C35.2409 3.59711 34.9774 3.47052 34.6961 3.45292C34.4147 3.43532 34.1375 3.5281 33.9235 3.71156L31.5727 5.72764C31.3854 5.91561 31.2736 6.16579 31.2585 6.43072C31.2422 6.70156 30.9324 13.1171 35.9071 18.0939C40.2469 22.4326 45.6831 22.7501 47.1802 22.7501C47.3991 22.7501 47.5334 22.7436 47.5692 22.7414C47.834 22.7266 48.0841 22.6143 48.2712 22.4261L50.2862 20.0742C50.4697 19.8603 50.5627 19.5832 50.5453 19.3019C50.5279 19.0205 50.4015 18.757 50.193 18.5673L45.7903 14.5633Z",
    fill: "#6B9BD7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 12.5,
    r: 2.5,
    fill: "#4C7EBD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 12.5,
    r: 2.5,
    fill: "#4C7EBD"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 12.5,
    r: 2.5,
    fill: "#4C7EBD",
    fillOpacity: 0.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 12.5,
    r: 2.5,
    fill: "#4C7EBD",
    fillOpacity: 0.3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 12.5,
    r: 2.5,
    fill: "#4C7EBD",
    fillOpacity: 0.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 12.5,
    r: 2.5,
    fill: "#4C7EBD",
    fillOpacity: 0.6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 12.5,
    r: 2.5,
    fill: "#4C7EBD",
    fillOpacity: 0.3
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 12.5,
    r: 2.5,
    fill: "#4C7EBD",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3);
export default __webpack_public_path__ + "static/media/Group3.7c6c4eaa9f178837c9dfa49cb454897f.svg";
export { ForwardRef as ReactComponent };